import styled from 'styled-components';

export const BannerSection = styled.section`
    background:#ddf5f6;
    padding:62px 0 50px 0; 
    
    @media screen and (max-width: 1024px){
      padding: 157px 0 50px 0;
    }
`;

export const BannerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 103px;
  
  @media screen and (max-width: 991px){
    gap: 50px;
  }
  
  @media screen and (max-width: 767px){
    flex-direction: column;
    gap: 0px;
  }
`;

export const BannerText = styled.div`
  width:100%;
  max-width:690px;
  
  @media screen and (max-width: 767px){
    text-align: center;
    margin: 0 auto;
  }

`;
export const BannerSmallText = styled.p`
  color: #333333;;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 400;
  line-height: 27px;
  margin-bottom: 15px;
  a{
      color:#01606F;
      font-weight: 700;
      text-decoration: none; 
  }
`;

export const MediaInquiries = styled.div`
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  text-align: center;
  padding: 20px;
  margin-top: 30px;
  ${BannerSmallText}{
      margin-bottom:0;
  }
  
`;
export const MediaInquiriesTitle = styled.h2`
  color: #01606F;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 700;
  line-height: 21px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgb(0 0 0 / 10%);
  padding-bottom: 12px;
`;

export const TopRatedListSection = styled.section`
  background: #F1FEFF;
  padding: 0px 0px 30px; 
`;

export const TableSection = styled.div`
  background: #F9FFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 30px #0000001A;
  border-radius: 20px;
  table{
    margin-bottom: 0;
  }
    td{
      span{
        display:none;
      }
    }
  .TableHeading{
    th{
    padding: 17px 30px !important;
    color: #fff !important;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    white-space: nowrap;
    background:#01606F !important;
    &:first-child{
      border-radius: 20px 0px 0px 0px;
    }
    &:last-child{
      border-radius: 0px 20px 0px   0px;
    }
    }
  }

  .TableBody{
    td{
      padding: 20px 30px !important;
      color: #333333 !important;
      font-family: "Jost", sans-serif;
      font-size:16px;
      font-weight: 500;
      white-space: nowrap;
    }
  }
`;
export const PaginationBlockNumber = styled.div`
background: #F1FEFF;
`;


export const TR = styled.tr`
   
`;

export const TH = styled.th`
  padding: 17px 30px !important;
  color: #fff !important;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 400;
  white-space: nowrap;
  background:#01606F !important;
 
  &:first-child{
    border-radius: 20px 0px 0px 0px;
  }
  &:last-child{
    border-radius: 0px 20px 0px   0px;
  }
`;

export const TD = styled.td`
  padding: 20px 30px !important;
  color: #333333 !important;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: 500;
  white-space: nowrap;
`;

export const Tbody = styled.tbody`
    tr:hover {background-color: coral;}
     tr{
    
      &:last-child{
      td{
        border: none;
        &:first-child{
          border-radius: 0px 0px 0px 20px;
        }
        &:last-child{
          border-radius:0px 0px 20px 0px;
        }
      }
    }
    }


`;

export const FilterSection = styled.div`
  display: flex;
  gap: 24px;
  
  @media screen and (max-width: 991px){
    flex-wrap: wrap;
  }

  @media screen and (max-width: 767px){
    gap: 15px 20px;
  }
   .dropdown{
     @media screen and (max-width: 991px){
      width:100%;
     }
   }
  .dropdown-toggle {
    width:100%;
    min-width:282px;
    text-align: left;
    @media screen and (max-width: 1200px){
        min-width:200px;
    }
   @media screen and (max-width: 991px){
        min-width:inherit;
        width:100%;

    }
    @media screen and (max-width: 767px){
      padding: 11px 60px 11px 15px;
      min-width: inherit;
    }
  } 
`;
export const SearchCol = styled.div`
    background: #F9DC70;
    border: none;
    border-radius: 10px;
    color: #333333;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    display: flex;
    align-items: center;
    width:100%;
    min-width:282px;
    @media screen and (max-width: 1024px){
      min-width:200px;
    }
    @media screen and (max-width: 767px){
      min-width: inherit;
      max-width: 100%;
    }
    input.form-control{
      background: transparent;
      border: none;
      padding: 0;
    }
    .input-group-text {
      background: transparent;
      border: none;
      padding: 12px;
    }
`;

export const TopList = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 0px;
    
    @media screen and (max-width: 480px){
      flex-direction: column;
    }
`;

export const TopHeading = styled.div`
  @media screen and (max-width: 480px){
    margin-bottom: 20px;
  }
`;

export const Title = styled.h3`
  color: #000000;
  font-family: "Jost", sans-serif;
  font-size:20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom:0px;
`;
export const ViewBtn = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;

  @media screen and (max-width: 480px){
    width: 100%;
  }

`;
export const ViewTitle = styled.h4`
  color: #000;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: 500;
  line-height: 30px;
  margin-bottom:0px;
`;
export const ViewIcon = styled.div`
background: rgb(51 167 174 / 50%) 0% 0% no-repeat padding-box;
border-radius: 10px;
padding:3px;
 
`;

export const ViewUl = styled.ul`
   list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
`;
export const ViewLi = styled.li`
padding: 8px;
border-radius: 6px;
cursor: pointer;
&.active{
  background: #01606F;
  svg{
    rect {
      fill: #fff;
    }
   }
}
`;

export const HeadingSection = styled.div`
  background:#F1FEFF;
  padding: 50px 0 30px 0;
`;

export const TopRatedGridSection = styled.div`
  background: #F1FEFF;
  padding-bottom:0px;
  
  .SeeMoreBtn{
    display:none;
  }

`;
export const Thead = styled.thead``;

export const TableList = styled.div`
  background: #F1FEFF;
`;

export const TopRatedListTable = styled.div`
  background: #F1FEFF;

  .table-section{
    background: transparent
  }
`;


export const AwardBrowse = styled.div`
.pagination-wrapper{
background: #F1FEFF;
}

`;